export { Location, type Props } from './index.pc'
export { MobileLocation } from './index.mobile'
